export const isValidHexColor = (color) => {
  return !!color && /^#([0-9a-f]{3}){1,2}$/i.test(color)
}

/**
 * Generate a color based on index using HSL color space
 * This ensures visually distinct colors for any number of entities
 */
export const generateColor = (index, total) => {
  const hue = (index * 360) / Math.max(total, 8) // Distribute colors evenly
  const saturation = 65 + (index % 3) * 10 // Vary saturation slightly
  const lightness = 45 + (index % 2) * 10 // Vary lightness slightly
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`
}
